import { Theme, useMediaQuery } from '@mui/material';

export type Breakpoint = 'sm' | 'md';

const useAboveMobile = (breakpoint: Breakpoint = 'md') =>
  useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));

export default useAboveMobile;
